import styled from '@emotion/styled';
import { RadioGroup as ADSRadioGroup } from '@qbe/ads-core';

// Fix to ADS RadioGroup component to allow our reusable InformationPopUp titlePrefix component to be positioned from the FormCard left border.
// Without the fix the popup is positioned from the RadioGroup's left border.
const RadioGroup = styled(ADSRadioGroup)`
  position: unset;
  align-items: center;
`;

export default RadioGroup;
